"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.obfuscate = void 0;
const lodash_1 = require("lodash");
// eslint-disable-next-line @typescript-eslint/ban-types
function obfuscate(obj, keys, replacement = '***') {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const recurse = (mem, val, key) => {
        if ((0, lodash_1.isObject)(val)) {
            mem[key] = (0, lodash_1.reduce)(val, recurse, {});
        }
        else if (keys.includes(key)) {
            mem[key] = replacement;
        }
        else {
            mem[key] = val;
        }
        // eslint-disable-next-line @typescript-eslint/no-unsafe-return
        return mem;
    };
    return (0, lodash_1.reduce)(obj, recurse, {});
}
exports.obfuscate = obfuscate;
//# sourceMappingURL=obfuscate.js.map